import { Box } from "@mui/material";
import { type GridColDef } from "@mui/x-data-grid";

import { type ProgressPoint } from "./ProgressPoints.data";

export const progressPointsColumns: GridColDef<ProgressPoint>[] = [
  {
    field: "id",
    headerName: "Point",
    width: 80,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "owner",
    headerName: "Owner",
    width: 160,
  },
  {
    field: "definition",
    headerName: "Definition",
    flex: 1,
    minWidth: 300,
    renderCell: ({ value }) => <Box sx={{ py: 1 }}>{value}</Box>,
  },
  {
    field: "notes",
    headerName: "Notes",
    flex: 1,
    minWidth: 250,
    renderCell: ({ value }) =>
      value ? <Box sx={{ py: 1 }}>{value}</Box> : null,
  },
];
